// removed by extract-text-webpack-plugin
module.exports = {"base":"Spinner_base--3042x","spinner":"Spinner_spinner--11p-4","spin":"Spinner_spin--1XwGm","caption":"Spinner_caption--BEkNu"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Spinner/Spinner.css
// module id = 1813
// module chunks = 16